export default {
  allowedRoomFileExts: '',
  roomFileList: [],
  uploadRoomFileList: [],
}
